const state = {
  tabList: [
    {
      name: 'Index',
      fullPath: '/index',
      meta: {
        title: '首页'
      }
    }
  ],
  cachedRouteNameList: []
}

const mutations = {
  // 新增tab
  addTabToList (state, item) {
    let index = state.tabList.findIndex(view => {
      return view.name === item.name
    })
    if (index >= 0) {
      state.tabList[index] = item
    } else {
      state.tabList.push(item)
    }
    state.cachedRouteNameList = state.tabList.map(item => item.name)
  },
  // 删除tab
  delTab (state, item) {
    let index = state.tabList.findIndex(view => {
      return view.name === item.name
    })
    state.tabList.splice(index, 1)
    state.cachedRouteNameList = state.tabList.map(item => item.name)
  },
  // 删除缓存
  deleteCacheRoute (state, item) {
    let name = item.name
    state.cachedRouteNameList = state.cachedRouteNameList.filter(item => {
      return item !== name
    })
    setTimeout(() => {
      state.cachedRouteNameList.push(name)
    }, 0)
  },
  // 清空tab页
  clearTabs (state) {
    state.tabList = [
      {
        name: 'Index',
        fullPath: '/index',
        meta: {
          title: '首页'
        }
      }
    ]
    state.cachedRouteNameList = []
  },
  // 关闭其他
  delOtherTabs (state, index) {
    state.tabList = state.tabList.filter((item, i) => {
      return i === 0 || i === index
    })
    state.cachedRouteNameList = state.tabList.map(item => item.name)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js